import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ECustomFunction } from '@se/cp.common';
import { CheckedDataService } from '@se/se.platform.base';
import { CpDatasourceService } from 'projects/cp-framework-engine/src/lib/cp-datasource.service';
import { CpNodeService } from 'projects/cp-framework-engine/src/lib/cp-node.service';
import { arrayFunctionsMap } from './custom-functions/arrayFunctions/arrayFunctions';
import { AutomaticSetKineticCombo } from './custom-functions/automaticSetKineticCombo/automaticSetKineticCombo';
import { AutomaticSetKineticComboParams } from './custom-functions/automaticSetKineticCombo/interfaces';
import { dateFunctionMap } from './custom-functions/dateFunctions/dateFunctions';
import { ClinicalEvalExporter } from './custom-functions/export-clinical-eval/export-clinical-eval';
import { ClinicalEvalExporterParams } from './custom-functions/export-clinical-eval/interfaces';
import { ExportSegmentalKinetic } from './custom-functions/exportSegmentalKinetic/exportSegmentalKinetic';
import { ExportSegmentalKineticParams } from './custom-functions/exportSegmentalKinetic/interfaces';
import { ExportVasselReport } from './custom-functions/exportVasselReport/exportVasselReport';
import { ExportVasselReportParams } from './custom-functions/exportVasselReport/interfaces';

@Injectable({
    providedIn: 'root',
})
export class CpUcConstraintFunctionsService {
    private functionsMap: Record<string, (...args: any[]) => any> = {};

    init(
        dataService: CheckedDataService,
        nodeService: CpNodeService,
        dataSourceService: CpDatasourceService,
        translateService: TranslateService,
    ) {
        const customFunctionsMap: Record<ECustomFunction, (...args: any[]) => any> = {
            EXPORTCLINICALEVAL: (params: ClinicalEvalExporterParams) => {
                const clinicalEvalExporter = new ClinicalEvalExporter(
                    dataService,
                    dataSourceService,
                    nodeService,
                    translateService,
                );
                clinicalEvalExporter.init();
                clinicalEvalExporter?.setParams(params);
                return clinicalEvalExporter?.exportText();
            },
            EXPORT_SEGMENTAL_KINETIC: (params: ExportSegmentalKineticParams) => {
                const exportSegmentalKinetic = new ExportSegmentalKinetic(
                    dataService,
                    dataSourceService,
                    translateService,
                );
                return exportSegmentalKinetic?.export(params);
            },
            AUTOMATIC_SET_KINETIC_COMBO: (params: AutomaticSetKineticComboParams) => {
                const automaticSetKineticCombo = new AutomaticSetKineticCombo(dataSourceService);
                return automaticSetKineticCombo.execute(params);
            },
            EXPORT_VASSEL_REPORT: (params: ExportVasselReportParams) => {
                const exportVasselReport = new ExportVasselReport(dataService, dataSourceService);
                return exportVasselReport.export(params);
            },
        };

        this.functionsMap = {
            ...customFunctionsMap,
            ...arrayFunctionsMap,
            ...dateFunctionMap,
        };
    }

    /*
     * per testare in formula-test tutte le funzioni di base che non abbiano bisogno
     * di import dei servizi come nell init qui sopra*/
    initCustomFunctions() {
        this.functionsMap = {
            ...this.functionsMap,
            ...arrayFunctionsMap,
            ...dateFunctionMap,
        };
    }

    get functionsEntries(): [string, (...args: any[]) => any][] {
        return Object.entries(this.functionsMap);
    }
}
